import { useEffect } from 'react'
import { RouterProvider } from '@tanstack/react-router'
import { useAuth } from '@/features/auth/AuthProvider'
import { useProfile } from '@/features/profile/ProfileProvider'
import { router } from './router'

export function App() {
  const auth = useAuth()
  const profile = useProfile()

  useEffect(() => {
    void router.invalidate()
  }, [auth.loading, auth.session, profile.loading, profile.profile])

  return <RouterProvider router={router} context={{ auth, profile }} />
}
